import React, { useState } from 'react';

import { ScrollArea } from "@/components/ui/scroll-area";

import moment from 'moment';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';

import ServiceSubs from 'services/serviceSubs';

export default function ComponentSubInfo(props) {

    const payMode = [
        { value: 'demo', label: 'Demo' },
        { value: 'cash', label: 'Cash' },
        { value: 'bank', label: 'Bank' },
        { value: 'upi', label: 'UPI' },
        { value: 'chq', label: 'Cheque' },
    ];

    const [mode, setMode] = useState('');

    const [isTouched, setIsTouched] = useState(false);
    const [submit, setSubmit] = useState(false);

    const formVSchema = Yup.object().shape({
        total: Yup.number().required('This information is required'),
        discount: Yup.number().required('This information is required'),
        gtotal: Yup.number().required('This information is required'),
        pmode: Yup.string().required('This information is required'),
    });

    const subsService = new ServiceSubs();

    const { values, errors, touched, handleChange, handleSubmit, handleReset, resetForm, setErrors, setValues } = useFormik({
        initialValues: {
            total: 0,
            discount: 0,
            gtotal: 0,
            pmode: '',
            pref: '',
        },
        validationSchema: formVSchema,
        enableReinitialize: true,
        onSubmit: values => {
            if (mode.length === 0) {
                toast.error("Please select subscription mode", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            } else {
                setSubmit(true);
                let body = {
                    "uid": props.record.subid,
                    "ordid": props.record.ordid._id,
                    "type": mode,
                    "total": values.total,
                    "tax": getTaxVal(),
                    "discount": values.discount,
                    "pmode": {
                        "mode": values.pmode,
                        "ref": values.pref
                    },
                };
                subsService.renewSubscription(body, '').then((res) => {
                    setSubmit(false);
                    if (res.status) {
                        resetForm();
                        setMode('');
                        setIsTouched(false);
                        props.onClose();
                        toast.success('Subscription renewed.', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    } else {
                        toast.error(res.msg, { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    }
                });
            }
        }
    });

    const subsMode = [
        { value: 'demo', label: 'demo' },
        { value: 'prod', label: 'prod' },
    ];

    function getRoundOff(data) {
        const finalTotal = (data.total - data.discount) + data.tax;
        const roundedTotal = Math.round(finalTotal);
        const roundOffValue = (roundedTotal - finalTotal).toFixed(2);
        if (roundOffValue === "0.00") {
            return roundOffValue;
        }
        return roundOffValue > 0 ? `+${roundOffValue}` : roundOffValue;
    }

    const getTaxVal = () => {
        return (values.total - values.discount) * 0.18;
    }

    const getGTotalVal = () => {
        return (values.total - values.discount) + getTaxVal();
    }

    const getAppTitle = (appid) => {
        switch (appid) {
            case "APP00001":
                return "Online Reporting";
            case "APP00002":
                return "Hostel Booking";
            default:
                return "NA";
        }
    }

    return (
        <div className='overflow-y-auto overflow-x-hidden z-[100] w-full h-modal md:h-full fixed top-0 left-0 bg-black bg-opacity-70'>
            <div className='bg-white w-[600px] min-h-screen absolute right-0 p-[20px]'>
                <ScrollArea>
                    <div className='px-2'>
                        <div className='flex items-center justify-between text-2xl'>
                            <h1 className='font-sans font-medium text-gray-900 uppercase'>SUB #{props.record.subid}</h1>
                            <div className='w-7 h-7 text-gray-700 flex items-center justify-center border border-black rounded-full hover:bg-black hover:text-white cursor-pointer' onClick={() => { props.onClose(); }}>
                                <span><i className="las la-times text-xl cursor-pointer"></i></span>
                            </div>
                        </div>
                        <div className='mt-2'>
                            Timestamp: <b>{moment(props.record.createdAt).format('DD MMM, yyyy hh:mm:ss A')}</b>
                        </div>
                        <hr className='my-2' />
                        <div className='p-2 bg-gray-200 w-full text-sm font-medium rounded mt-4 flex justify-between items-center'>
                            <span className='flex items-center'>
                                <i className="las la-file-invoice mr-2 text-xl"></i>Subscription Summery
                            </span>
                        </div>
                        <div className='mt-4 flex items-center'>
                            <p className='text-sm font-bold text-gray-950'>Particulars</p>
                            <div className='flex-grow'></div>
                            <p className='text-sm font-bold text-gray-950'>ID</p>
                        </div>
                        <hr className='my-2' />
                        <div className='flex items-center'>
                            <p className='text-sm  font-medium text-gray-950'>Organization Info</p>
                            <div className='flex-grow'></div>
                            <p className='text-sm font-medium'>#{props.record.ordid.ordid}</p>
                        </div>
                        <div className='flex items-center'>
                            <p className='text-sm  font-medium text-gray-950'>Subscription Info</p>
                            <div className='flex-grow'></div>
                            <p className='text-sm font-medium'>#{props.record.subid}</p>
                        </div>
                        <div className='flex items-center'>
                            <p className='text-sm  font-medium text-gray-950'>Subscription Mode</p>
                            <div className='flex-grow'></div>
                            <p className='text-sm font-medium uppercase'>{props.record.subtype}</p>
                        </div>
                        <div className='flex items-center'>
                            <p className='text-sm  font-medium text-gray-950'>No. License</p>
                            <div className='flex-grow'></div>
                            <p className='text-sm font-medium'>{props.record.totalLicenses} (.lic)</p>
                        </div>
                        <div className='flex items-center'>
                            <p className='text-sm  font-medium text-gray-950'>Start Date</p>
                            <div className='flex-grow'></div>
                            <p className='text-sm font-medium'>{moment(props.record.startDate).format("DD, MMM yyyy")}</p>
                        </div>
                        <div className='flex items-center'>
                            <p className='text-sm  font-medium text-gray-950'>End Date</p>
                            <div className='flex-grow'></div>
                            <p className='text-sm font-medium'>{moment(props.record.endDate).format("DD, MMM yyyy")}</p>
                        </div>
                        <hr className='my-2' />
                        {
                            !props.isRenew && <div>
                                <div class="w-full mt-2 space-y-1">
                                    <div class="flex justify-between">
                                        <span class="font-medium text-sm">Subtotal</span>
                                        <span class="font-medium text-sm">₹ {props.record.total.toFixed(2)}</span>
                                    </div>
                                    <div class="flex justify-between">
                                        <span class="font-medium text-sm">Discount (-)</span>
                                        <span class="font-medium text-sm">₹ {props.record.discount.toFixed(2)}</span>
                                    </div>
                                    <div class="flex justify-between">
                                        <span class="font-medium text-sm">CGST(2.5%)</span>
                                        <span class="font-medium text-sm">₹ {(props.record.tax / 2).toFixed(2)}</span>
                                    </div>
                                    <div class="flex justify-between">
                                        <span class="font-medium text-sm">SGST(2.5%)</span>
                                        <span class="font-medium text-sm">₹ {(props.record.tax / 2).toFixed(2)}</span>
                                    </div>
                                    <div class="flex justify-between">
                                        <span class="font-medium text-sm">Round off</span>
                                        <span class="font-medium text-sm">₹ {getRoundOff(props.record)}</span>
                                    </div>
                                    <div class="border-t-2 mt-2 py-2 flex items-center justify-between">
                                        <span class="font-medium text-lg">Grand Total</span>
                                        <span class="font-medium text-lg">₹ {Math.round((props.record.total - props.record.discount) + props.record.tax).toFixed(2)}</span>
                                    </div>
                                </div>
                                <div className='p-2 bg-gray-200 w-full text-sm font-medium rounded mt-2 flex justify-between items-center'>
                                    <span className='flex items-center'>
                                        <i className="las la-file-invoice mr-2 text-xl"></i>Payment Summery
                                    </span>
                                </div>
                                <div className='mt-4 flex items-center'>
                                    <p className='text-sm font-bold text-gray-950'>Particulars</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-bold text-gray-950'>ID</p>
                                </div>
                                <hr className='my-2' />
                                <div className='flex items-center'>
                                    <p className='text-sm  font-medium text-gray-950'>Payment Mode</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-medium uppercase'>{props.record.pmode.mode}</p>
                                </div>
                                <div className='flex items-center'>
                                    <p className='text-sm  font-medium text-gray-950'>Payment Ref</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-medium'>{props.record.pmode.ref}</p>
                                </div>
                                <div className='flex items-center'>
                                    <p className='text-sm  font-medium text-gray-950'>Status</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-medium uppercase'>{props.record.status}</p>
                                </div>
                                <hr className='my-2' />
                                <div className='p-2 bg-gray-200 w-full text-sm font-medium rounded mt-4 flex justify-between items-center'>
                                    <span className='flex items-center'>
                                        <i className="las la-file-invoice mr-2 text-xl"></i>Modules Summery
                                    </span>
                                </div>
                                <div className='mt-4 flex items-center'>
                                    <p className='text-sm font-bold text-gray-950'>Particulars</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-bold text-gray-950'>Status</p>
                                </div>
                                <hr className='my-2' />
                                <div className='flex items-center'>
                                    <p className='text-sm  font-medium text-gray-950'>Inventory</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-medium uppercase'>{props.record.features.isInv ? "enabled " : "Disabled"}</p>
                                </div>
                                <div className='flex items-center'>
                                    <p className='text-sm  font-medium text-gray-950'>KDS</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-medium uppercase'>{props.record.features.isKds ? "enabled " : "Disabled"}</p>
                                </div>
                                <div className='flex items-center'>
                                    <p className='text-sm  font-medium text-gray-950'>Room Booking</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-medium uppercase'>{props.record.features.isRoom ? "enabled " : "Disabled"}</p>
                                </div>
                                <div className='flex items-center'>
                                    <p className='text-sm  font-medium text-gray-950'>Taxation</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-medium uppercase'>{props.record.features.isTax ? "enabled " : "Disabled"}</p>
                                </div>
                                <div className='flex items-center'>
                                    <p className='text-sm  font-medium text-gray-950'>CRM</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-medium uppercase'>{props.record.features.isCrm ? "enabled " : "Disabled"}</p>
                                </div>
                                <div className='p-2 bg-gray-200 w-full text-sm font-medium rounded mt-4 flex justify-between items-center'>
                                    <span className='flex items-center'>
                                        <i className="las la-file-invoice mr-2 text-xl"></i>Installed Apps Summery
                                    </span>
                                </div>
                                <div className='mt-4 flex items-center'>
                                    <p className='text-sm font-bold text-gray-950'>Particulars</p>
                                    <div className='flex-grow'></div>
                                    <p className='text-sm font-bold text-gray-950'>Status</p>
                                </div>
                                <hr className='my-2' />
                                {
                                    props.record.apps.map((aap) => {
                                        return <div className='flex items-center'>
                                            <p className='text-sm  font-medium text-gray-950'>{getAppTitle(aap)}</p>
                                            <div className='flex-grow'></div>
                                            <p className='text-sm font-medium uppercase'>{aap}</p>
                                        </div>
                                    })
                                }
                            </div>
                        }
                        {
                            props.isRenew && <div>
                                <div className="col-span-4">
                                    <label className="block text-xs font-medium text-gray-700 font-mono">Subscription Mode<sup className="text-red-600">*</sup></label>
                                    <select id="mode" className="border-gray-300 border rounded appearance-none w-full py-1 px-2 bg-white mt-2" onChange={(e) => {
                                        setMode(e.target.value);
                                        setIsTouched(true);
                                    }} value={mode}>
                                        <option value="" disabled="" selected="selected">Select</option>
                                        {
                                            subsMode.length !== 0 && subsMode.map((item) => {
                                                return <option value={item.value} selected={mode == item.value}>{item.label}</option>
                                            })
                                        }
                                    </select>
                                    {(mode.length === 0 && isTouched) && <p className='text-xs text-red-400 mt-1'>This information is required</p>}
                                </div>

                                <form className='mt-4 grid grid-cols-4 gap-3' onSubmit={handleSubmit} onReset={handleReset} noValidate="" autoComplete='off'>

                                    <div className="col-span-4">
                                        <label className="block text-xs font-medium text-gray-700 font-mono mb-2">Total<sup className="text-red-600">*</sup></label>
                                        <input type="number" id="total" value={values.total} autoComplete='off' className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="" onChange={handleChange} />
                                        {(errors.total && touched.total) && <p className='text-xs text-red-400 mt-1'>{errors.total}</p>}
                                    </div>

                                    <div className="col-span-4">
                                        <label className="block text-xs font-medium text-gray-700 font-mono mb-2">Discount<sup className="text-red-600">*</sup></label>
                                        <input type="number" id="discount" value={values.discount} autoComplete='off' className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="" onChange={handleChange} />
                                        {(errors.discount && touched.discount) && <p className='text-xs text-red-400 mt-1'>{errors.discount}</p>}
                                    </div>

                                    <div className="col-span-4">
                                        <label className="block text-xs font-medium text-gray-700 font-mono mb-2">Tax (18%)<sup className="text-red-600">*</sup></label>
                                        <input type="number" id="tax" readOnly={true} value={getTaxVal()} autoComplete='off' className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="" />
                                        {(errors.tax && touched.tax) && <p className='text-xs text-red-400 mt-1'>{errors.tax}</p>}
                                    </div>

                                    <div className="col-span-4">
                                        <label className="block text-xs font-medium text-gray-700 font-mono mb-2">Grand Total<sup className="text-red-600">*</sup></label>
                                        <input type="number" id="gtotal" readOnly={true} value={getGTotalVal()} autoComplete='off' className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="" />
                                        {(errors.gtotal && touched.gtotal) && <p className='text-xs text-red-400 mt-1'>{errors.gtotal}</p>}
                                    </div>

                                    <div className="col-span-4">
                                        <label className="block text-xs font-medium text-gray-700 font-mono">Payment Mode<sup className="text-red-600">*</sup></label>
                                        <select id="pmode" className="border-gray-300 border rounded appearance-none w-full py-1 px-2 bg-white mt-2" onChange={handleChange} value={values.pmode}>
                                            <option value="" disabled="" selected="selected">Select</option>
                                            {
                                                payMode.length !== 0 && payMode.map((item) => {
                                                    return <option value={item.value} selected={values.pmode == item.value}>{item.label}</option>
                                                })
                                            }
                                        </select>
                                        {(errors.pmode && touched.pmode) && <p className='text-xs text-red-400 mt-1'>{errors.pmode}</p>}
                                    </div>

                                    <div className="col-span-4">
                                        <label className="block text-xs font-medium text-gray-700 font-mono mb-2">Payment Ref</label>
                                        <input type="text" id="pref" value={values.pref} autoComplete='off' className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. xxxxxx" onChange={handleChange} />
                                        {(errors.pref && touched.pref) && <p className='text-xs text-red-400 mt-1'>{errors.pref}</p>}
                                    </div>

                                    <div className='col-span-4 flex mt-4'>
                                        <button type="submit" class="py-2 rounded-md shadow-lg text-center bg-prime text-white font-semibold cursor-pointer flex-grow">
                                            RENEW SUBSCRIPTION
                                        </button>
                                    </div>

                                </form>
                            </div>
                        }
                    </div>
                </ScrollArea >
            </div >
        </div >
    )
}
